export default "__VITE_ASSET__DCdXXHc6__"